import { createStart } from "@tanstack/react-start";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";

// Global function middleware: attaches the Supabase bearer token to every
// serverFn RPC call from the browser. Without this, any serverFn protected
// by `requireSupabaseAuth` returns 401.
export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth],
}));
